import { render, staticRenderFns } from "./AdminTokens.vue?vue&type=template&id=2a5568fc&"
import script from "./AdminTokens.vue?vue&type=script&lang=js&"
export * from "./AdminTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports